import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {StudiewijzerlinkjesNewFacade} from '../../state/studiewijzerlinkjes/studiewijzerlinkjes.facade';

@Component({
    selector: 'app-studiewijzer-donut-new',
    templateUrl: './studiewijzer-donut-new.component.html',
    styleUrls: ['./studiewijzer-donut-new.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StudiewijzerDonutNewComponent implements OnInit {

  constructor(store: StudiewijzerlinkjesNewFacade) { }

  ngOnInit(): void {
  }

}
